export const CREDIT_ROUTING = [
    {
        path: '/vi-tien.html',
        name: 'credit',
        component: () => import('./Credit.vue'),
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Nạp - rút tiền', icon: 'fa fa-money' },
        ] },
        children: [], 
    }
];